module.exports = __webpack_public_path__ + "static/media/susi_shrimp.a47af30d.jpeg";